import React from 'react';
import { prepareData } from 'utils/googleData';
import Subscribe from 'components/Subscribe';
import { CallToAction } from 'components/CallToAction';
import Scroll from 'react-scroll';

export const EventFooter = (props) => {
    const {
        enable,
        title,
        subtitle,
        cta,
        direction
    } = prepareData({ props });
    const scroll = Scroll.animateScroll;

    const scrollToForm = () => {
        scroll.scrollTo(document.getElementById('registration-form').offsetTop, {
            duration: 1500,
            delay: 100,
            smooth: 'easeInOutQuint'
        });
    };

    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return null;
    }

    return (
        <div direction={direction} className="bg-gray-50 p-8">
            <div className="border-t border-dashed border-gray-300 pt-10 text-center">
                {title && <h3 className="text-2xl font-bold m-0">{title}</h3>}
                {subtitle && <p className="mt-4 mb-10 text-lg text-gray-600">
                    {subtitle}
                </p>}
                {cta ? (
                    <div className="flex flex-col items-center space-y-4">
                        <CallToAction  onClick={scrollToForm} width={cta.width} type={cta.type}>
                            {cta.label}
                        </CallToAction>
                    </div>
                ) : (
                    <Subscribe />
                )}
            </div>
        </div>
    );
};

export default EventFooter;
